import React from "react";
import PropTypes from "prop-types";
import Linkify from "react-linkify";
import Util from "../common/util";

function MessageContent(props) {
  const { content, created_at } = props;

  return (
    <React.Fragment>
      <Linkify properties={{target: "_blank"}}>
        <p>{Util.newLineToBrTag(content)}</p>
      </Linkify>
      <span className='time-date'>{created_at}</span>
    </React.Fragment>
  );
}

MessageContent.propTypes = {
  content: PropTypes.string.isRequired,
  created_at: PropTypes.string.isRequired
};

export default MessageContent;
